import Header from '../../Header';
import Navigation from '../Navigation';
import * as S from './style';

interface FullWidthLayoutProps {
  children: React.ReactNode;
  hideNavbar?: boolean;
  hideHeader?: boolean;
  headerType?: 'default' | 'survey';
}

const FullWidthLayout = ({
  children,
  hideNavbar,
  hideHeader,

  headerType = 'default'
}: FullWidthLayoutProps) => {
  return (
    <>
      <S.LayoutContainer>
        {!hideNavbar && <Navigation />}
        {!hideHeader && <Header headerType={headerType} />}
        <S.ContentDiv container item>
          {children}
        </S.ContentDiv>
      </S.LayoutContainer>
    </>
  );
};

export default FullWidthLayout;
